export enum AuthError {
  RefreshAccessTokenError = 'RefreshAccessTokenError',
  MaxSessionDurationError = 'MaxSessionDurationError',
}

export type AuthFlow = 'signin' | 'registration' | 'impersonation'

export enum UserRole {
  None = 'None',
  Customer = 'Customer',
  ImpersonatedUser = 'ImpersonatedUser',
  FirmUser = 'FirmUser',
  MasterFirmUser = 'MasterFirmUser',
  CorporateUser = 'CorporateUser',
  MasterCorporateUser = 'MasterCorporateUser',
}
